import { styled } from '@mui/material';

export const WarningContainer = styled('div')`
  width: 100%;
  text-align: center;
  margin-top: 250px;
`;
